export function collectFamilyInteractionLineGroups(events, graph) {
  const lineGroups = []
  events
    .filter(event => event.eventType === 'Family Interaction')
    .forEach(event => {
      const interacteeIds = Array.isArray(event.interacteeID)
        ? event.interacteeID
        : [event.interacteeID]
      const participantIds = [event.interactorID, ...interacteeIds]
      const points = participantIds
        .map(id => `Player${id}`)
        .map(playerId => [
          graph.getCharacterX(playerId, event.timestamp),
          graph.getCharacterY(playerId, event.timestamp),
        ])
        .filter(point => Number.isFinite(point[0]) && Number.isFinite(point[1]))
        .sort((a, b) => a[1] - b[1])
      if (points.length > 1) lineGroups.push(points)
    })
  return lineGroups
}

export function drawFamilyInteractionLines(eventsGroup, lineGroups) {
  lineGroups.forEach(group => {
    for (let index = 0; index < group.length - 1; index += 1) {
      eventsGroup
        .line(
          group[index][0],
          group[index][1],
          group[index + 1][0],
          group[index + 1][1]
        )
        .attr({
          stroke: '#222',
          'stroke-width': 2,
          'stroke-dasharray': '6,6',
          class: 'mock-event-dotted-line',
        })
    }
  })
}
